import { useSelector } from 'react-redux'

import { getTenantPartnerIdFromState } from './partnerStateSelectors'
import { useUserType } from './useUserType'

export const useTenantPartnerId = () => {
  const userType = useUserType()
  return useSelector(state => getTenantPartnerIdFromState(state, userType))
}
